<template>
  <v-card :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
    <v-row dense class="pt-6">
      <v-col cols="12" sm="9" md="10" lg="10">
        <v-text-field class="search-field" v-model="search" prepend-icon="mdi-magnify" label="Search by Trading Acc..."
          single-line solo hide-details>
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="3" md="2" lg="2">
        <ul class="mt-0 text-center">
          <li><span>Active Clients</span><span> {{ investorclients?.data?.total_acc }}</span></li>
        </ul>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="12">
        <v-card class="pa-3 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
          <v-sheet class="transactionTable depositTabTable pb-3" :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'">
            <v-data-table :search="search" :headers="headers" :items="investorclients?.data?.accounts"
              :items-per-page="6">

              <template v-slot:item.inv_status="{ item }">
                <div class="status-selection text-center">
                  <v-switch :input-value="Boolean(item.inv_status)" @change="handleStatus(item)" inset color="#039de9"
                    :ripple="false">
                    <template v-slot:label>
                      <span class="account-status">{{ item.inv_status === 1 ? 'Active' : 'Inactive' }}</span>
                    </template>
                  </v-switch>
                </div>
              </template>

              <template v-slot:item.level="{ item }">
                <div class="user-profile">
                  <div class="profile-image">
                    <v-badge bordered overlap small icon="mdi-star-outline" size="10" :class="verifyBadge(item.symb)">
                      <v-avatar size="32" class="red-darken-2">
                        <span class="text-small">L{{ item.level }}</span>
                      </v-avatar>
                    </v-badge>
                  </div>
                </div>
              </template>

              <template v-slot:item.name="{ item }">
                <router-link class="text-capitalize" :to="`/registered-user-details/${item?.client_account_id}`">
                  <span class="ib-links">{{ item.fname }} {{ item.lname }}</span> <span class="account-status">({{
                    item.client_account_id }})</span>
                </router-link>
              </template>

              <template v-slot:item.commission="{ item }">
                <span class="text-capitalize text-decoration-none text--green">0.00</span>
              </template>

            </v-data-table>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { TRADEMASTER__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      search: '',
      managerAccount: '',
      headers: [
        { text: "Level", value: "level" },
        { text: "Client Name", value: "name" },
        { text: "Reg Dtae & Time", value: "created_at" },
        { text: "Acc No.", value: "trading_account_no" },
        { text: "Total Deposit", value: "total" },
        { text: "Commission", value: "commission" },
        { text: "Status", value: "inv_status" }
      ],
    };
  },

  computed: {
    ...mapState("trademaster", ["investorclients"]),
  },

  methods: {
    ...mapActions("trademaster", [TRADEMASTER__ACTIONS.GETINVESTORCLIENTS, TRADEMASTER__ACTIONS.CHANGEINVESTORSTATUS]),

    verifyBadge(symb) {
      if (symb) return "show-badge";
      else return "hide-badge";
    },

    async getInvestors() {
      const parameters = {
        account: this.managerAccount,
        search: this.search,
      }
      await this[TRADEMASTER__ACTIONS.GETINVESTORCLIENTS](parameters);
    },

    async handleStatus(item) {
      const newStatus = !item.inv_status ? 1 : 0;
      try {
        await this[TRADEMASTER__ACTIONS.CHANGEINVESTORSTATUS]({
          id: item.inv_id,
          status: newStatus,
          account: item.trading_account_no,
          search: this.search,
        })
      } catch (error) {
        console.log(error)
      } finally {
        this.getInvestors();
      }

    },

  },

  async mounted() {
    this.managerAccount = this.$route.query.account;
    this.getInvestors();
  }
};
</script>


<style scoped>
.account-status {
  text-align: center !important;
  font-weight: 400;
  font-size: 12px;
  line-height: 26px;
  color: #b4c2d1;
  text-decoration: none;
}

.ib-links {
  color: #039de9;
  text-decoration: underline;
}
</style>